module.exports = __webpack_public_path__ + "media/unipod/icon-floor-tiling-black-b74dad8d.svg";